/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { CommonKeyCombinations } from "../../common/KeyCombinations";
import { IEditor } from "../../IEditor";
import { termsEditorActionEditor } from "../../terms/actionEditor";

export function registerKeyBindings(dc: IEditor): void {
	const viewSvc = dc.get("viewService");
	const keyBindingSvc = dc.get("keyBindingService");

	keyBindingSvc.register({
		id: "actionEditor.edit.toggleLeftPanel",
		commandId: "actionEditor.edit.toggleLeftPanel",
		label: termsEditorActionEditor.commands.toggleLeftPanel,
		keys: CommonKeyCombinations.toggleLeftPanel,
		when: () => viewSvc.isViewActive("actionEditor.edit")
	});

	keyBindingSvc.register({
		id: "actionEditor.edit.toggleRightPanel",
		commandId: "actionEditor.edit.toggleRightPanel",
		label: termsEditorActionEditor.commands.toggleRightPanel,
		keys: CommonKeyCombinations.toggleRightPanel,
		when: () => viewSvc.isViewActive("actionEditor.edit")
	});

	keyBindingSvc.register({
		id: "actionEditor.edit.hideAllPanels",
		commandId: "actionEditor.edit.hideAllPanels",
		label: termsEditorActionEditor.commands.hideAllPanels,
		keys: CommonKeyCombinations.hideAllPanels,
		when: () => viewSvc.isViewActive("actionEditor.edit")
	});

	keyBindingSvc.register({
		id: "actionEditor.edit.toggleConsole",
		commandId: "actionEditor.edit.toggleConsole",
		label: termsEditorActionEditor.commands.toggleConsole,
		keys: CommonKeyCombinations.toggleConsole,
		when: () => viewSvc.isViewActive("actionEditor.edit")
	});

	keyBindingSvc.register({
		id: "actionEditor.edit.saveResource",
		label: termsEditorActionEditor.commands.saveResource,
		commandId: "actionEditor.edit.saveResource",
		keys: CommonKeyCombinations.save,
		when: () => viewSvc.isViewActive("actionEditor.edit")
	});

	keyBindingSvc.register({
		id: "actionEditor.edit.undo",
		label: termsEditorActionEditor.commands.undo,
		commandId: "actionEditor.edit.undo",
		keys: CommonKeyCombinations.undo,
		when: () => {
			if (viewSvc.isViewActive("actionEditor.edit")) {
				return viewSvc.hasModifiedViews();
			}
		}
	});

	keyBindingSvc.register({
		id: "actionEditor.edit.redo",
		label: termsEditorActionEditor.commands.redo,
		commandId: "actionEditor.edit.redo",
		keys: CommonKeyCombinations.redo,
		when: () => {
			if (viewSvc.isViewActive("actionEditor.edit")) {
				return viewSvc.hasModifiedViews();
			}
		}
	});
}
